import { Link } from "react-router-dom";
import styled from "styled-components";
import {COLORS} from "../../utils/constants";

export const NameWrapper = styled(Link)`
  display: flex;
  align-items: center;
`;

export const Title = styled.h1`
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 8px;
  color: ${COLORS.WHITE};
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;
`;

export const Container = styled.div`
  margin-top: 25px;
`;

export const BarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 40px 0;
`;
